 export const serverProtocol = location.protocol == 'http:' ? 'http://' : 'https://'
 export const server = serverProtocol + (document.domain == 'pe.ntu.edu.tw' ? 'pe.ntu.edu.tw/api/pe/' : 'ntu.pe.dev.com.tw:5001/api/pe/');
 export const rentserver = serverProtocol + (document.domain == 'pe.ntu.edu.tw' ? 'pe.ntu.edu.tw/api/rent/' : 'ntu.pe.dev.com.tw:5001/api/rent/');
 // export const rentserver = serverProtocol + 'pe.ntu.edu.tw/api/rent/';


 export const workBench = server + 'workbench/';
 export const common = server + 'common/';
 export const basePath = "/";
 export const loginPage = basePath + "workbench/index.html";
 export const indexPage = basePath + "workbench/common/index.html";

 //這個由B設定, F使用
 //v1/StatusCode 會產生下面的資訊, F 再copy paste 過來使用
 //動態產生會有問題1. 開發期間沒辦法用IDE 幫忙, 2. 除非用async/await, always 還是會有call back 問題
 export const StatusCode = {
   "OK": 200,
   "Save_Form_Data_Fail": 301,
   "Update_Form_Data_Fail": 302,
   "Delete_Form_Data_Fail": 303,
   "Session_Invalid": 401,
   "API_Access_Denied": 402,
   "Login_Fail": 403,
   "Validation_Wizard": 500,
   "Validation_KeyWord_Fail": 501,
   "Validation_Account_Password_Fail": 502,
   "ExcelTemplate_Fail": 404,
   "ExcelTemplate_Columns_Should_be_Array_Fail": 405,
   "Upload_File_Fail": 406,
   "Change_Password_Request_Data_Empty": 407,
   "Reset_Password_Data_Empty": 408,
   "Reset_Password_Fail": 409,
   "Reset_Password_Fail_Cant_Find_Email": 410,
   "EmailTemplate_Fail": 411,
   "EmailNotification_Data_Empty": 412,
   "EmailNotification_Sent_Fail": 413,
   "Update_SEQ_Fail": 414,
   "Update_SEQ_Empty": 415,
   "Update_Columns_Fail": 416,
   "Validation_Wizard": 500,
   "Validation_KeyWord_Fail": 501,
   "Validation_Account_Password_Fail": 502,

   "Data_Exist": 601,
   "Data_Not_Exist": 602,
   "Data_Not_Match": 603,
   "Verify_Fail": 604,
   "Application_Exist": 605,
   "Link_Exist": 606,
   "ReCAPTCHA_Fail": 607,
   "File_Not_Exist": 608,
   "Sub_Node_Exist": 609,
   "Data_Be_Used": 610,

   "Data_Exist": 631,
   "Data_Not_Exist": 632,
   "Data_Not_Match": 633,
   "Account_Not_Active": 634,
   "Data_Is_Limit": 635,
   "Not_Active": 636,
   "Over_Limit": 637,
   "ReCAPTCHA_Fail": 638,
   "No_Cancel": 639,
   "Data_Be_Used": 640,
   "Minutes_Later": 641,

   "Account_Exist": 666,
   "PassWord_Empty": 667
 };

 //這個應該要由SA 或SD 設定, B, F使用, menuTop.js 要用的
 //定義這個系統的總角色
 export const Role = {
   //   ROLE_ADMIN = "ADMIN";       //管理員
   // ROLE_STAFF = "STAFF";       //職員
   // ROLE_TEACHER = "TEACHER";   //教師
   // ROLE_TEAM = "TEAM";
   ADMIN: "ADMIN",
   STAFF: "STAFF",
   TEACHER: "TEACHER",
   AGENT: "AGENT",
   TEAM: "TEAM",
   RENT: "RENT",
   USER: "YEARUSER", // 場地租借前台

 };

 //定義API完整路徑
 export const API = {
   course: server + 'course', //課程
   class: server + 'class', //班別
   classadmissions: server + 'classadmissions', //課程班別招生
   classcoach: server + 'classcoach', //課程班別教練
   application: server + 'application', //課程班別報名

   album: server + 'album', //相簿
   picture: server + 'picture', //相片
   site: server + 'site', //場地
   video: server + 'video', //影片

   teacher: server + 'teacher', //師資
   teacherpublication: server + 'teacherpublication', //師資著作
   teacherpublication1: server + 'teacherpublication?type=1', //師資著作 研討
   teacherpublication2: server + 'teacherpublication?type=2', //師資著作 期刊
   teacherpublication3: server + 'teacherpublication?type=3', //師資著作 專書
   teacherpublication4: server + 'teacherpublication?type=4', //師資著作 專題
   teacherCustom: server + 'teacherCustom', //師資自訂項目

   notice: server + 'notice', //公告
   journal: server + 'journal', //期刊
   code: server + 'code', //類別代碼
   message: server + 'message', //留言板

   team: server + 'team', //代表隊

   setting: server + 'setting', //首頁彈跳視窗設定
   link: server + 'link', //連結
   webpage: server + 'webpage', //零碎頁面
   webpagepart: server + 'webpagepart', //零碎頁面內容
   menu: server + 'menu', //選單管理
   fun: server + 'fun', //系統功能

   login: server + 'login', //登入
   ssologin: server + 'ssologin', //SSO登入
   admin: server + 'admin', //帳號
   menurole: server + 'menurole', //選單角色
   defcolumns: server + 'defcolumns', //預設欄位
   columns: server + 'Columns',
   serverTime: server + 'serverTime',

   rent_notice: rentserver + 'notice', //公告
   rent_periodoption: rentserver + 'periodoption', //租借時段
   rent_building: rentserver + 'building', //建物名稱
   rent_venue: rentserver + 'venue', //場地
   rent_yearoption: rentserver + 'yearoption', //年度帳號開放時間
   rent_yearuser: rentserver + 'yearuser', //年度帳號
   rent_yearuserapply: rentserver + 'yearuserapply', //年度帳號 展延
   rent_yearuserrent: rentserver + 'yearuserrent', //年度帳號 租借
   rent_yearuserrent2: rentserver + 'yearuserrent', //年度帳號 租借
   rent_yearuserrent3: rentserver + 'yearuserrent', //年度帳號 租借
   rent_activityused: rentserver + 'activityused', //活動管理
   rent_yearuserblacklist: rentserver + 'yearuserblacklist', //年度帳號 黑名單
   rent_schedulesetting: rentserver + 'schedulesetting', //排程設定
   rent_schedulesettinglog: rentserver + 'schedulesettinglog', //排程設定紀錄
   rent_login: rentserver + 'login',
   rent_ssologin: rentserver + 'ssologin',
   rent_ssoapply: rentserver + 'ssoapply',
   rent_admin: rentserver + 'admin',
   rent_code: rentserver + 'code', //類別代碼
   rent_password: rentserver + 'password',
   rent_columns: rentserver + 'Columns',
   rent_defcolumns: rentserver + 'defcolumns', //預設欄位
   rent_serverTime: rentserver + 'serverTime',
   rent_functiontest: rentserver + 'functiontest', //測試

 };


 // ENUM
 export const ENUM = {
   language: {
     ch: { CH: "中文", },
     en: { CH: "英文", }
   },
   isActive: {
     1: {
       CH: "上架",
       EN: "Active"
     },
     0: {
       CH: "下架",
       EN: "Inactive"
     },
   },
   type: {
     0: { CH: "女子代表隊", EN: "" },
     1: { CH: "男子代表隊", EN: "" }
   },
   isDisplay: {
     1: {
       CH: "是",
       EN: "Y"
     },
     0: {
       CH: "否",
       EN: ""
     },
   },
   title: {
     0: {
       CH: "",
       EN: ""
     },
     1: {
       CH: "教授",
       EN: ""
     },
     2: {
       CH: "副教授",
       EN: ""
     },
     3: {
       CH: "助理教授",
       EN: ""
     },
     4: {
       CH: "特聘教授",
       EN: ""
     },
     5: {
       CH: "專任講師",
       EN: ""
     },
     6: {
       CH: "兼任教授",
       EN: ""
     },
     7: {
       CH: "兼任副教授",
       EN: ""
     },
     8: {
       CH: "兼任助理教授",
       EN: ""
     },
     9: {
       CH: "兼任講師",
       EN: ""
     },
     10: {
       CH: "專任助教",
       EN: ""
     },
     11: {
       CH: "名譽教授",
       EN: ""
     },
   },
   status: {
     1: {
       CH: "已受理報名",
       EN: ''
     },
     0: {
       CH: "未處理",
       EN: ''
     },
   },
   coach: {
     1: {
       CH: "男教練",
       EN: ''
     },
     0: {
       CH: "女教練",
       EN: ''
     },
     2: {
       CH: "指定教練",
       EN: ''
     }
   },

   sex: {
     0: { CH: "女", EN: "" },
     1: { CH: "男", EN: "" },
     2: { CH: "不提供", EN: "" },
   },
   deptConsular: {
     0: {
       CH: "否",
       EN: ""
     },
     1: {
       CH: "是",
       EN: ""
     }
   },
   deptHead: {
     0: {
       CH: "否",
       EN: ""
     },
     1: {
       CH: "是",
       EN: ""
     }
   },
   deptManager: {
     0: {
       CH: "否",
       EN: ""
     },
     1: {
       CH: "是",
       EN: ""
     }
   },
   labManager: {
     0: {
       CH: "否",
       EN: ""
     },
     1: {
       CH: "是",
       EN: ""
     }
   },
   showOption: {
     0: {
       CH: "否"
     },
     1: {
       CH: "是"
     }
   },
   replyDisplay: {
     1: { CH: "是", EN: "Y" },
     0: { CH: "否", EN: "" },
   }
 };
 export const ENUM_RENT = {
   buildingGroup: {
     1: { CH: "體育室" },
     2: { CH: "綜合體育館" }
   },
   statusConfirm: {
     0: { CH: "未確認" },
     1: { CH: "已確認" }
   },
   statusRent: {
     1: { CH: "已預約" },
     2: { CH: "已登記抽籤" },
     3: { CH: "已取消" }
   },
   status: {
     0: { CH: "未處理" },
     1: { CH: "通過" },
     2: { CH: "未通過" },
   },
   isActive: {
     1: {
       CH: "上架",
       EN: "Active"
     },
     0: {
       CH: "下架",
       EN: "Inactive"
     },
   },
   unitType: {
     1: { CH: "大學部" },
     2: { CH: "研究所" },
     3: { CH: "社團" },
   },
   teamType: {
     0: { CH: "" },
     1: { CH: "男子籃球隊" },
     2: { CH: "男子排球隊" },
     3: { CH: "男子足球隊" },
     4: { CH: "棒球隊" },
     5: { CH: "女子籃球隊" },
     6: { CH: "女子排球隊" },
     7: { CH: "女子足球隊" },
     8: { CH: "壘球隊" },
     9: { CH: "9" },
   },
   isDisplay: {
     1: { CH: "是", EN: "Y" },
     0: { CH: "否", EN: "" },
   },

 }

 export const ENUM_Usage = {
   admin: ['isDisplay'],
   link: ['isActive'],
   notice: ['isActive'],
   message: ['isDisplay', 'replyDisplay'],
   team: ['type'],
   teacher: ['isDisplay', 'title'],
   application: ['status', 'coach', 'sex'],
   webpage: ['language'],
   building: ['isDisplay'],
   yearuser: ['status', 'unitType', 'teamType', 'buildingGroup'],
   yearuserrent: ['statusConfirm', 'statusRent', 'unitType', 'teamType'],
   yearuserrent2: ['statusConfirm', 'statusRent', 'unitType', 'teamType'],
   yearuserrent3: ['statusConfirm', 'statusRent', 'unitType', 'teamType'],
   yearuserblacklist: ['unitType', 'teamType'],
   yearuserapply: ['status', 'buildingGroup'],
 };

 // i18n
 export const ColumnName = {
   link: {
     pictureUrl: { CH: '預覽圖' },
     nameCh: { CH: '名稱' },
     nameEn: { CH: '英文名稱' },
     isActive: { CH: '狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   webpage: {
     title: { CH: '網頁標題' },
     menuTitleCh: { CH: '對應列表' },
     language: { CH: '語系' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' },
   },
   notice: {
     title: { CH: '標題' },
     typeNameCh: { CH: '類別' },
     typeNameEn: { CH: '類別(英文)' },
     sDateTime: { CH: '發佈開始時間' },
     isActive: { CH: '狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' },
     typeName: { CH: '類別' },

   },
   site: {
     nameCh: { CH: '場地名稱' },
     nameEn: { CH: '英文場地名稱' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '最後修改人員' }
   },
   course: {
     schoolYear: { CH: '學年度' },
     nameCh: { CH: '課程名稱' },
     nameEn: { CH: '課程英文名稱' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   class: {
     nameCh: { CH: '中文名稱' },
       nameEn: { CH: '英文名稱' },
       updatedAt: { CH: '最後修改' },
       updatedByName: { CH: '最後修改人員' }
   },
   classAdmissions: { //目前沒用到
     classLevel: { CH: '' },
     memberType: { CH: '' },
     minMember: { CH: '' },
     maxMember: { CH: '' },
     classHour: { CH: '' },
     classSite: { CH: '' }
   },
   admin: {
     jobTitleCh: { CH: '職稱' },
     jobTitleEn: { CH: '英文職稱' },
     nameCh: { CH: '姓名' },
     nameEn: { CH: '英文姓名' },
     isDisplay: { CH: '前台顯示狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   teacher: {
     isDisplay: { CH: '前台' },
     nameCh: { CH: '中文姓名' },
     nameEn: { CH: '英文姓名' },
     title: { CH: '職稱' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   teacherpublication1: {
     title: { CH: '論文標題' },
     author: { CH: '作者 (群)' },
     nameCh: { CH: '名稱' },
     nameEn: { CH: '英文名稱' },
     place: { CH: '會議地點' },
     area: { CH: '出版領域' },
     pageSE: { CH: '刊載頁範圍' },
     publicationAt: { CH: '刊載日期' },
     memo: { CH: '備註' }
   },
   teacherpublication2: {
     title: { CH: '論文標題' },
     author: { CH: '作者 (群)' },
     nameCh: { CH: '名稱' },
     nameEn: { CH: '英文名稱' },
     journal: { CH: '刊載期號' },
     pageSE: { CH: '刊載頁範圍' },
     publicationAt: { CH: '刊載日期' },
     memo: { CH: '備註' }
   },
   teacherpublication3: {
     title: { CH: '書名' },
     author: { CH: '作者 (群)' },
     nameCh: { CH: '出版社' },
     nameEn: { CH: '出版社(英文)' },
     reviewSystem: { CH: '審查制度' },
     isbn: { CH: 'ISBN' },
     publicationCountry: { CH: '出版國' },
     publicationPages: { CH: '頁數' },
     publicationAt: { CH: '出版年份' },
     memo: { CH: '備註' }
   },
   teacherpublication4: {
     nameCh: { CH: '計畫名稱 (中文)' },
     nameEn: { CH: '計畫名稱 (英文)' },
     fundSourceCh: { CH: '經費來源 (中文)' },
     fundSourceEn: { CH: '經費來源 (英文)' },
     planNo: { CH: '計畫編號' },
     fundBudget: { CH: '經費預算' },
     executiveDateSE: { CH: '執行期間' },
     memo: { CH: '備註' }
   },
   team: {
     nameCh: { CH: '體育代表隊名稱' },
     nameEn: { CH: '英文名稱' },
     type: { CH: '種類' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' },
   },

   message: {
     guestName: { CH: '留言者' },
     guestMessage: { CH: '留言內容' },
     isDisplay: { CH: '前台顯示' },
     replyDisplay: { CH: '發佈狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '最後修改人員' }
   },
   journal: {
     title: { CH: '名稱' },
     typeNameCh: { CH: '類別' },
     typeNameEn: { CH: '類別(英文)' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   code: {
     nameCh: { CH: '類別名稱' },
     nameEn: { CH: '類別名稱(英文)' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   application: {
     courseNameCh: { CH: '課程名稱' },
     classNameCh: { CH: '班別' },
     name: { CH: '姓名' },
     sex: { CH: '性別' },
     email: { CH: 'email' },
     mobile: { CH: '手機' },
     birthday: { CH: '生日' },
     coachName: { CH: '教練需求' },
     status: { CH: '處理狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' },
   },
   yearoption: {
     rocYear: { CH: '學年度' },
     beginTime: { CH: '開放時間' },
     endTime: { CH: '結束時間' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   yearuser: {
     rocYear: { CH: '申請年度' },
     unitName: { CH: '申請系所' },
     unitType: { CH: '申請系所種類' },
     teamType: { CH: '申請類別' },
     buildingGroup: { CH: '申請場館' },
     status: { CH: '狀態' },
     account: { CH: '帳號' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' },
   },
   periodoption: {
     timePeriod: { CH: '時段' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   yearuserapply: {
     rocYear: { CH: '申請年度' },
     unitName: { CH: '申請系所' },
     unitType: { CH: '申請系所種類' },
     teamType: { CH: '申請類別' },
     buildingGroup: { CH: '申請場館' },
     status: { CH: '審核狀態' },
     account: { CH: '帳號' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   yearuserrent: {
     yearUserUnitName: { CH: '系所' },
     unitType: { CH: '系所種類' },
     teamType: { CH: '類別' },
     account: { CH: '帳號' },
     buildingName: { CH: '預約建物' },
     venueName: { CH: '預約場地' },
     rentDate: { CH: '預約日期' },
     rentTimePeriod: { CH: '預約時段' },
     confirmDeadLine: { CH: '取消期限' },
     createdAt: { CH: '創建時間' },
     statusConfirm: { CH: '確認狀態' },
     statusRent: { CH: '狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   yearuserrent2: {
     yearUserUnitName: { CH: '系所' },
     unitType: { CH: '系所種類' },
     teamType: { CH: '類別' },
     account: { CH: '帳號' },
     unitName: { CH: '無帳號單位名稱' },
     buildingName: { CH: '預約建物' },
     venueName: { CH: '預約場地' },
     rentDate: { CH: '預約日期' },
     rentTimePeriod: { CH: '預約時段' },
     confirmDeadLine: { CH: '取消期限2' },
     createdAt: { CH: '創建時間' },
     statusConfirm: { CH: '確認狀態' },
     statusRent: { CH: '狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   yearuserrent3: {
     yearUserUnitName: { CH: '系所' },
     unitType: { CH: '系所種類' },
     teamType: { CH: '類別' },
     account: { CH: '帳號' },
     buildingName: { CH: '預約建物' },
     venueName: { CH: '預約場地' },
     rentDate: { CH: '預約日期' },
     rentTimePeriod: { CH: '預約時段' },
     confirmDeadLine: { CH: '取消期限3' },
     createdAt: { CH: '創建時間' },
     statusConfirm: { CH: '確認狀態' },
     statusRent: { CH: '狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   building: {
     buildingName: { CH: '名稱' },
     isDisplay: { CH: '前台顯示狀態' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   venue: {
     buildingName: { CH: '建物名稱' },
     venueName: { CH: '名稱' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   activityused: {
     activityName: { CH: '活動名稱' },
     unitName: { CH: '主辦單位' },
     beginDate: { CH: '活動開始日期' },
     endDate: { CH: '活動結束日期' },
     timePeriod: { CH: '活動時段' },
     buildingVenueName: { CH: '活動地點' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   yearuserblacklist: {
     rocYear: { CH: '學年度' },
     month: { CH: '月份' },
     account: { CH: '帳號' },
     unitName: { CH: '系所名稱' },
     unitType: { CH: '系所種類' },
     teamType: { CH: '類別' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' }
   },
   menurole: {
     name: { CH: '名稱' },
     memo: { CH: '備註' },
     updatedAt: { CH: '最後修改' },
     updatedByName: { CH: '操作人員' },
   },
 };

 export const Message = {
   AccountPassword: { EN: "Please input account / password", CH: "請輸入帳號密碼" },
   AccountPasswordError: { EN: "Account/Password can't be empty", CH: "帳號密碼錯誤" },
   AccountExist: { EN: "Account exist", CH: "帳號已存在" },

   Add: { EN: "Add", CH: "新增" },
   Delete: { EN: "Delete", CH: "刪除" },
   Edit: { EN: "Edit", CH: "編輯" },
   Save: { EN: "Save", CH: "儲存" },
   Back: { EN: "Back", CH: "回上一頁" },
   SaveSuccessfully: { EN: "Save Successfully", CH: "儲存成功" },
   SaveFail: { EN: "Save Fail", CH: "儲存失敗" },

   DeleteSuccessfully: { EN: "Delete Successfully", CH: "刪除成功" },
   DeleteFail: { EN: "Delete Fail", CH: "刪除失敗" },
   DeleteConfirm: { EN: "Please confirm you want to delete the record(s).", CH: "確認是否刪除?" },

   SearchKeyword: { EN: "Search key word", CH: "搜尋關鍵字" },
   IsInvalid: { EN: " is invalid", CH: "欄位無效" },
   CanNotBeEmpty: { EN: " can't be empty", CH: "不能為空" },
   PaginationLeft: { CH: "每頁顯示", EN: "Records per page" },
   PaginationRight: { CH: "筆", EN: "" },

   NoAuth: { CH: "沒有授權! Token 可能已失效, 請重新登入", EN: "Access Denied! Token may has been expired, please login again." },
   Case_Is_Close: { CH: "已結案", EN: "" }, // 613
   Not_Started: { CH: "尚未啟用", EN: "" }, // 614
   Expired: { CH: "超過期限", EN: "" }, // 615
   LaboratoryId_Not_Exist: { CH: "非校方實驗室", EN: "" }, // 616
   Lab_Exist: { CH: "實驗室已存在", EN: "" }, // 617
   NoQueryData: { CH: "查無資料。", EN: "" },
 };

 // menuTop

 export const HomeMenu = {
   title: { CH: '體育室網站管理' },
   firstLevel: {
     'home': {
       role: [Role.ADMIN, Role.STAFF, Role.TEACHER, Role.TEAM, Role.AGENT],
       title: { CH: '首頁' },
       url: '/home',
       secondLevel: {
         'content': {
           role: [Role.ADMIN, Role.STAFF],
           title: { CH: '網站內容' },
           url: '',
           thirdLevel: {
             'menuweb': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '選單網頁' },
               url: '/home/menu_web',
               menuKey: 'm01'
             },
             'otherweb': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '零碎網頁' },
               url: '/home/other_web',
               menuKey: 'm02'
             },
             'link': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '相關連結' },
               url: '/home/link',
               menuKey: 'm03'
             },
             'popup': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '首頁設定' },
               url: '/home/pop_up',
               menuKey: 'm04'
             }
           }
         },
         'photovideo': {
           role: [Role.ADMIN, Role.STAFF],
           title: { CH: '相簿影片管理' },
           url: '',
           thirdLevel: {
             'photo': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '相簿管理' },
               url: '/home/photo',
               menuKey: 'm05'
             },
             'video': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '影片管理' },
               url: '/home/video',
               menuKey: 'm06'
             }
           }
         },
         'classes': {
           role: [Role.ADMIN, Role.STAFF],
           title: { CH: '運動指導班' },
           url: '',
           thirdLevel: {
             'class': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '課程管理' },
               url: '/home/class',
               menuKey: 'm18'
             },
             'apply': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '課程報名管理' },
               url: '/home/apply',
               menuKey: 'm19'
             }
           }
         },
         'announcements': {
           role: [Role.ADMIN, Role.STAFF],
           title: { CH: '公告管理' },
           url: '',
           thirdLevel: {
             'announcement': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '公告管理' },
               url: '/home/announcement',
               menuKey: 'm07'
             },
             'announcement_type': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '類別設定' },
               url: '/home/announce_type',
               menuKey: 'm08'
             }
           }
         },
         'files': {
           role: [Role.ADMIN, Role.STAFF],
           title: { CH: '期刊及學報' },
           url: '',
           thirdLevel: {
             'file': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '檔案管理' },
               url: '/home/files',
               menuKey: 'm09'
             },
             'file_type': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '類別設定' },
               url: '/home/file_type',
               menuKey: 'm10'
             }
           }
         },
         'other': {
           role: [Role.ADMIN, Role.STAFF],
           title: { CH: '更多功能' },
           url: '',
           thirdLevel: {
             'member': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '員工管理' },
               url: '/home/member',
               menuKey: 'm11'
             },
             'menurole': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '角色管理' },
               url: '/home/menu_role',
               menuKey: 'm12'
             },
             'site': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '場地介紹' },
               url: '/home/site',
               menuKey: 'm13'
             },
             'guestbook': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '留言板管理' },
               url: '/home/guest_book',
               menuKey: 'm15'
             },
             'teacher': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '師資介紹' },
               url: '/home/teacher',
               menuKey: 'm16'
             },
             'team': {
               role: [Role.ADMIN, Role.STAFF],
               title: { CH: '體育代表隊管理' },
               url: '/home/team',
               menuKey: 'm17'
             },
           }
         },
         'teacheredit': {
           role: [Role.TEACHER, Role.AGENT],
           title: { CH: '編輯教師資料' },
           url: '/home/teacher/-1/teacher_edit'
         },

         'teamalbum': {
           role: [Role.TEAM],
           title: { CH: '體育代表隊管理' },
           url: '/home/team/-1/team_edit'
         },

       }
     }
   }
 };

 export const RentMenu = {
   title: { CH: '場地租借管理' },
   firstLevel: {
     'home': {
       role: [Role.ADMIN, Role.RENT],
       title: { CH: '首頁' },
       url: '/home',
       secondLevel: {
         'account': {
           role: [Role.ADMIN, Role.RENT],
           title: { CH: '年度帳號申請' },
           url: '',
           thirdLevel: {
             'schedule': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '日程設定' },
               url: '/home/schedule'
             },
             'accoutmanage': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '帳號管理' },
               url: '/home/accout_manage'
             },
             'accoutapply': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '帳號申請' },
               url: '/home/accout_apply'
             },
             'extendapply': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '帳號展延申請' },
               url: '/home/extend_apply'
             }
           }
         },
         'reserve': {
           role: [Role.ADMIN, Role.RENT],
           title: { CH: '場地預約登記' },
           url: '',
           thirdLevel: {
             'rentmanage': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '租借時段管理' },
               url: '/home/rent_manage'
             },
             'build': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '建物管理' },
               url: '/home/build'
             },
             'sitemanage': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '場地管理' },
               url: '/home/site_manage'
             },
             'activitymanage': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '活動管理' },
               url: '/home/activity_manage'
             },
             'reserverecord': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '場地預約紀錄' },
               url: '/home/reserve_record'
             },
             'lotschedule': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '各項排程設定' },
               url: '/home/lot_schedule'
             },
             'sitelot': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '場地登記抽籤' },
               url: '/home/site_lot'
             },
             'blacklist': {
               role: [Role.ADMIN, Role.RENT],
               title: { CH: '黑名單管理' },
               url: '/home/blacklist'
             }
           }
         },
         'announcement': {
           role: [Role.ADMIN, Role.RENT],
           title: { CH: '公告管理' },
           url: '/home/announcement'
         },
         'member': {
           role: [Role.ADMIN, Role.RENT],
           title: { CH: '員工管理' },
           url: '/home/member'
         },
         'testfunction': {
           role: [Role.ADMIN],
           title: { CH: '測試' },
           url: '/home/testfunction'
         },
       }
     }
   }
 };

 const Language = {
   home: { CH: '首頁', EN: 'Home' },

   class_inside: { CH: '上課注意事項', EN: 'Class Notes' },
   class_item: { CH: '課程說明', EN: 'Course Description' },
   coach_info: { CH: '教練簡介', EN: 'Coach Profile' },
   facility: { CH: '場地設施', EN: 'Facility' },

   coach_info_title: { CH: '教練群', EN: 'Coach Group' },
   apply_class: { CH: '開放報名班別', EN: 'Apply Class' },
   apply_batch: { CH: '開放報名梯次', EN: 'Apply Batch' },
   batch: { CH: '報名梯次', EN: 'Apply Batch' },
   identity: { CH: '　身份別', EN: 'Identity' },
   ABC: { CH: 'ABC非舊生', EN: 'ABC NOT Old Student' },
   people: { CH: '人', EN: 'people' },
   application: { CH: '報名', EN: 'application' },
   signup: { CH: '我要報名', EN: 'Sign up' },
   name: { CH: '姓名', EN: 'Name' },
   sex: { CH: '性別', EN: 'Sex' },
   male: { CH: '男', EN: 'male' },
   female: { CH: '女', EN: 'female' },
   unkown: { CH: '未提供', EN: 'unkown' },
   license: { CH: '證照', EN: 'License' },
   history: { CH: '經歷', EN: 'History' },
   ID: { CH: '身分證字號', EN: 'ID number' },
   birthday: { CH: '出生年月日', EN: 'Birthday' },
   parent: { CH: '家長', EN: 'Parent' },
   serviceunits: { CH: '服務單位', EN: 'Service Units' },
   tel: { CH: '聯絡電話', EN: 'Tel' },
   mobile: { CH: '手機', EN: 'Mobile' },
   address: { CH: '聯絡地址', EN: 'Address' },
   classtype: { CH: '報名班別', EN: 'Class Type' },
   adult: { CH: '成人', EN: 'Adult' },
   child: { CH: '兒童', EN: 'Child' },
   charges: { CH: '收費標準', EN: 'Charges' },
   onCampus: { CH: '校內身分', EN: 'OnCampus' },
   offCampus: { CH: '校外身分', EN: 'OffCampus' },
   applynote: {
     CH: '校內身分泛指：本校學生、本校教職員工及教職員工眷屬；校外身分泛指：校友、校外人士',
     EN: 'School identity refers to: our students, our faculty and faculty and staff dependents; off-campus means: alumni, outsiders'
   },
   classWeek: { CH: '上課星期', EN: 'Class Week' },
   classcount: { CH: '每週希望上課堂數', EN: 'Class Count' },
   lesson: { CH: '堂', EN: 'lesson' },
   classtime: { CH: '上課時段', EN: 'Class Time' },
   mon: { CH: '一', EN: 'Mon' },
   tue: { CH: '二', EN: 'Tue' },
   wed: { CH: '三', EN: 'Wed' },
   thu: { CH: '四', EN: 'Thu' },
   fri: { CH: '五', EN: 'Fri' },
   sat: { CH: '六', EN: 'Sat' },
   sun: { CH: '日', EN: 'Sun' },
   other: { CH: '其他', EN: 'Other' },
   coachrequirements: { CH: '教練需求', EN: 'Coach Requirements' },
   coachMale: { CH: '男教練', EN: 'Male Coach' },
   coachFeMale: { CH: '女教練', EN: 'Female Coach' },
   coachSpecified: { CH: '指定教練', EN: 'Specified Coach' },
   agree: {
     CH: '我已詳閱上課須知及各注意事項，並同意遵行',
     EN: 'I have read the class notes and all the notes, and agreed to comply'
   },

   contactName: { CH: '緊急聯絡人', EN: 'Contact People' },
   contactRelationship: { CH: '關係', EN: 'Relationship' },
   contactMobile: { CH: '聯絡電話', EN: 'Contact Mobile' },


   administrativeMember: { CH: '行政成員介紹', EN: 'Administrative Member' },
   jobTitle: { CH: '職稱', EN: 'Job Title' },
   activityGroup: { CH: '組別', EN: 'Activity Group ' },

   officePhone: { CH: '辦公室電話', EN: 'Office Phone' },
   business: { CH: '承辦業務', EN: 'Business' },
   agent: { CH: '代理人', EN: 'Agent' },

   collegeMember: { CH: '師資介紹', EN: 'Teacher' },
   honoraryProfessor: { CH: '名譽教授', EN: 'Honorary Professor' },
   professor: { CH: '專任教授', EN: 'Professor' },
   associateProfessor: { CH: '專任副教授', EN: 'Associate Professor' },
   assistantProfessor: { CH: '專任助理教授', EN: 'Assistant Professor' },
   fullTimeLecturer: { CH: '專任講師', EN: 'Full-time Lecture' },
   adjunctProfessor: { CH: '兼任教授', EN: 'Adjunct Professor' },
   adjunctAssociateProfessor: { CH: '兼任副教授', EN: 'Adjunct Associate Professor' },
   adjunctAssistantProfessor: { CH: '兼任助理教授', EN: 'Adjunct Assistant Professor' },
   adjunctLecture: { CH: '兼任講師', EN: 'Adjunct Lecture' },
   teachingAssistant: { CH: '專任助教', EN: 'Teaching Assistant' },
   teacherMemberCount: { CH: '教師成員共', EN: 'Teacher Member: ' },
   teacherSearch: { CH: '教師搜尋', EN: 'Teacher Search' },
   personalInformation: { CH: '個人資料', EN: 'Personal Information' },
   educationCourses: { CH: '學歷 & 課程', EN: 'Education & Courses' },
   awardsExperiences: { CH: '獲獎 & 經歷', EN: 'Awards & Experiences' },
   seminar: { CH: '研討會論文', EN: 'Seminar Paper' },
   journal: { CH: '期刊論文', EN: 'Journal Paper' },
   book: { CH: '專書及專書論文', EN: 'Book Paper' },
   research: { CH: '專題研究報告', EN: 'Research Report' },

   officeLocation: { CH: '辦公室位置', EN: 'Office Location' },
   consultationTime: { CH: '諮詢時段', EN: 'Consultation Time' },
   personalWebpage: { CH: '個人網頁', EN: 'Personal Webpage' },

   researchArea: { CH: '主要研究領域', EN: 'Research Area' },
   researchSummary: { CH: '研究領域摘要', EN: 'Research Summary' },

   education: { CH: '學歷', EN: 'Education' },
   course: { CH: '課程', EN: 'Course' },

   degree: { CH: '學位', EN: 'Degree' },
   school: { CH: '校名', EN: 'School' },
   school_en: { CH: '校名(英文)', EN: 'School(EN)' },
   graduation_year: { CH: '畢業西元年', EN: 'Graduation Year' },

   award: { CH: '獲獎', EN: 'Award' },
   experience: { CH: '經歷', EN: 'Experience' },

   // paperTitle: {CH: '論文標題', EN: 'Paper Title'},
   author: { CH: '作者', EN: 'Author' },
   journalTitle: { CH: '期刊名稱', EN: 'Journal Title' },
   issueNumber: { CH: '刊載期號', EN: 'Issue Number' },
   publishPageRange: { CH: '刊載頁範圍', EN: 'Publish Page Range' },
   publicationAt: { CH: '期刊日期', EN: 'Publication Date' },
   memo: { CH: '備註', EN: 'Memo' },

   conferenceName: { CH: '會議名稱', EN: 'Conference Name' },
   conferencePlace: { CH: '會議地點', EN: 'Conference Place' },
   area: { CH: '出版領域', EN: 'Publish Area' },

   publishingHouse: { CH: '出版社', EN: 'Publishing House' },
   censorship: { CH: '審查制度', EN: 'Censorship' },
   publicationCountry: { CH: '出版國', EN: 'Publication Country' },
   page: { CH: '頁數', EN: 'Page' },

   fundSource: { CH: '經費來源', EN: 'Fund Source' },
   planNo: { CH: '計畫編號', EN: 'PlanNo' },
   fundBudget: { CH: '經費預算', EN: 'Fund Budget' },
   executiveDate: { CH: '執行期間', EN: 'Executive Date' },

   menTeam: { CH: '男子代表隊', EN: "Men's Team" },
   womenTeam: { CH: '女子代表隊', EN: "Women's Team" },
   totalCount: { CH: '共', EN: "Total: " },
   item: { CH: '項目', EN: ' item' },
   search: { CH: '查詢', EN: 'Search' },
   album: { CH: '相簿', EN: 'Album' },
   albumSearch: { CH: '相簿查詢', EN: 'Album Search' },

   leaveMessage: { CH: '留言', EN: 'Leave Message' },
   reply: { CH: '回覆', EN: 'Reply' },

   back: { CH: '回上一頁', EN: 'Back' },
   guestName: { CH: '留言者', EN: 'Guest Name' },
   message: { CH: '留言', EN: 'Message' },
   verificationCode: { CH: '驗證碼', EN: 'Verification Code' },
   change: { CH: '換一張', EN: 'Change' },

   type: { CH: '類別', EN: 'Type' },
   fileName: { CH: '名稱', EN: 'Name' },

   orderByReleaseDate: { CH: '依上架日期排序', EN: 'OrderByReleaseDate' },
   cancel: { CH: '取消', EN: 'Cancel' },
   videoSearch: { CH: '影片查詢', EN: 'Video Search' },
 }
 export function ShowPage(locale) {
   var showPage = {};
   for (var key in Language) {
     if (Language.hasOwnProperty(key)) {
       showPage[key] = Language[key][locale];
     }
   }
   return showPage;
 }



// WEBPACK FOOTER //
// ./src/assets/project_setting/config.js